<div *ngIf="inputMetadata['data']">
  {{inputMetadata['data']}}
</div>
